import { BaseComponent } from '../base-component.js';

export class AgPanelHeader extends BaseComponent {
  protected styles(): string {
    return '';
  }

  protected template(): string {
    return `<div class="ag-panel-header"><slot></slot></div>`;
  }
}

customElements.define('ag-panel-header', AgPanelHeader);
